import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge 必须认识 tailwind.config.ts 里自定义的字号。
 * 不登记时它把 `text-body` 当成文字颜色，与后面的 `text-ink-2` 判为冲突并**静默删掉**
 * 字号 —— 元素退回继承字号，界面上看不出报错（2026-09-19 纸面令牌接入时由测试抓到；
 * 旧的 `text-2xs` 与颜色类同用时也一直被删）。
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['2xs', 'caps', 'code', 'data', 'body', 'heading', 'title'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
